const mapKey = 'X3KBZ-Z376O-HXHW3-SSP2I-4HSZZ-H4FCC'

const defaultLocation = ['22.678299','113.98836']


export default {
  mapKey,
  defaultLocation,
}
